module.exports = __webpack_public_path__ + "img/jingying.6a153685.jpg";